import { render, staticRenderFns } from "./SexySetting.vue?vue&type=template&id=3f475a56&scoped=true&"
import script from "./SexySetting.vue?vue&type=script&lang=js&"
export * from "./SexySetting.vue?vue&type=script&lang=js&"
import style0 from "./SexySetting.vue?vue&type=style&index=0&id=3f475a56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f475a56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
